import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

// Lucide icons (replacing font awesome)
import { 
  Search, 
  RotateCcw, 
  X, 
  Mail, 
  Calendar,
  User,
  FileText,
  ChevronLeft,
  ChevronRight,
  Edit,
  Clock
} from "lucide-react";

import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";
import './EmailLogs.css'

function EmailLogs({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getUsers = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const userData = await api.getEmailLogs(payload);
      console.log(userData);
      setData(userData.logs);
      setnoOfUser(userData.count);
      setLimit(userData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        query: searchMail,
      };
      const res = await api.searchEmailLogs(payload);
      if (res?.success) {
        setData(res?.logs);
        setLimit(res?.logs?.length || 10);
        setnoOfUser(res?.logs?.length || 0);
      } else {
        alert("Invalid Email Address");
      }
    } else {
      alert("Please insert email for search");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  useEffect(() => {
    getUsers();
  }, [page, resetPage]);

  const handleReset = () => {
    setSearchMail("");
    setResetPage(!resetPage);
    setPage(1);
  };

 return (
    <>
      <div className="el-email-logs-container">
        {/* Header Section */}
        <div className="el-email-logs-header">
          <div className="el-headers-content">
            <div className="el-header-left">
              <div className="el-title-with-icon">
                <Mail size={50} className="el-header-icon" />
                <div>
                  <h1 className="el-page-title">Email Logs</h1>
                  <p className="el-page-subtitle">View and manage all sent email records</p>
                </div>
              </div>
              <div className="el-email-count-badge">{noOfUser}</div>
            </div>

            <div className="el-header-right">
              <div className="el-search-container">
                <div className="el-search-input-group">
                  <div className="el-search-input-with-icon">
                    <Search size={18} className="el-search-input-icons" />
                    <input
                      type="text"
                      className="el-search-input"
                      placeholder="Search by To, Subject..."
                      value={searchMail}
                      onChange={(e) => setSearchMail(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                    {searchMail && (
                      <button 
                        className="el-clear-search-btn" 
                        onClick={() => setSearchMail("")}
                      >
                        <X size={16} />
                      </button>
                    )}
                  </div>
                  <button className="el-search-action-btn" onClick={handleSearch}>
                    <Search size={18} />
                    Search
                  </button>
                  <button className="el-reset-action-btn" onClick={handleReset}>
                    <RotateCcw size={18} />
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="el-email-logs-table-container">
          <div className="el-table-card">
            <div className="el-table-header">
              <div className="el-table-header-left">
                <Clock size={20} />
                <span>Email History</span>
              </div>
              <div className="el-table-header-right">
                <span className="el-total-records">
                  {data.length} of {noOfUser} records
                </span>
              </div>
            </div>
            
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfUser={noOfUser}
              limit={limit}
              adminType={adminType}
              handleShowEdit={handleShowEdit}
            />
          </div>
        </div>

        {/* Edit Modal */}
        <Modal
          show={showEdit}
          size="lg"
          onHide={handleCloseEdit}
          centered
          className="el-email-modal"
        >
          <Modal.Body className="el-email-modal-body">
            <div className="el-modal-header-custom">
              <div className="el-modal-title-section">
                <div className="el-modal-icon">
                  <Edit size={20} />
                </div>
                <h3 className="el-modal-title">Edit Email Details</h3>
              </div>
              <button className="el-modal-close-btn" onClick={handleCloseEdit}>
                <X size={24} />
              </button>
            </div>
            
            <div className="el-modal-content-custom">
              <EditUserData
                getUsers={getUsers}
                setShow={setShowEdit}
                selectedData={selectedData}
              />
            </div>
          </Modal.Body>
        </Modal>
      </div>
      
      {/* Loader */}
      {loader && <Loader />}
    </>
  );
}

const Table = ({ data, page, setPage, noOfUser, limit }) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const formatTimeAgo = (date) => {
    return moment(date).fromNow();
  };

  return (
    <>
      <div className="el-email-table-wrapper">
        <div className="el-table-responsive">
          <table className="el-email-table">
            <thead>
              <tr>
                <th className="el-table-column">
                  <div className="el-column-header">
                    <Calendar size={16} />
                    <span>Send At</span>
                  </div>
                </th>
                <th className="el-table-column">
                  <div className="el-column-header">
                    <User size={16} />
                    <span>To</span>
                  </div>
                </th>
                <th className="el-table-column">
                  <div className="el-column-header">
                    <FileText size={16} />
                    <span>Subject</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, key) => (
                  <tr key={key} className="el-table-row">
                    <td className="el-table-cell">
                      <div className="el-cell-content">
                        <div className="el-date-time">
                          {formatDate(item?.createdAt)}
                        </div>
                        <div className="el-time-ago">
                          {formatTimeAgo(item?.createdAt)}
                        </div>
                      </div>
                    </td>
                    <td className="el-table-cell">
                      <div className="el-recipient-cell">
                        <div className="el-recipient-avatar">
                          {item?.title?.charAt(0) || 'U'}
                        </div>
                        <div className="el-recipient-info">
                          <div className="el-recipient-name">
                            {item?.title || 'No recipient'}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="el-table-cell">
                      <div className="el-subject-cell">
                        <div className="el-subject-text">
                          {item?.subject || 'No subject'}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="el-empty-row">
                  <td colSpan="3" className="el-empty-cell">
                    <div className="el-table-empty-state">
                      <div className="el-empty-state-icon">
                        <Mail size={48} />
                      </div>
                      <h3 className="el-empty-state-title">No Email Logs Found</h3>
                      <p className="el-empty-state-description">
                        No email records are available. When emails are sent, they will appear here.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        
        {/* Pagination - Show only when there's data */}
        {data.length > 0 && noOfUser > limit && (
          <div className="el-table-pagination">
            <div className="el-pagination-info">
              Showing {((page - 1) * limit) + 1} to {Math.min(page * limit, noOfUser)} of {noOfUser} entries
            </div>
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfUser / limit)}
                page={page}
                onChange={handleChange}
                color="primary"
                shape="rounded"
                size="medium"
                showFirstButton
                showLastButton
              />
            </Stack>
          </div>
        )}
      </div>
      
    </>
  );
};

export default EmailLogs;